import api from './api'

export const crmStages = ['new','contacted','qualified','demo_scheduled','proposal_sent','negotiating','won','lost'] as const
export interface CrmLead {
  id:string; companyName:string; contactName:string; email:string; phone:string|null; industry:string|null;
  status:string; salesRepId:string|null; salesRep?:{id:string;name:string}; estimatedArrCents:number|null; tenantId:string|null; updatedAt:string
}
export interface CrmEvent {id:string;lead_id:string;activity_type:string;title:string;body:string|null;created_at:string;metadata:{dueAt?:string;completedAt?:string;proposalUrl?:string}}
export interface CrmOverview {
  scope:{all:boolean;manageAll:boolean;manage:boolean;team:boolean;configure:boolean;commissions:boolean};
  modules:{activitiesEnabled:boolean;proposalsEnabled:boolean};leads:CrmLead[];page:number;total:number;
  reps:Array<{id:string;name:string;email:string}>;stages:Array<{status:string;count:number;arr:number}>;
  reminders:Array<Pick<CrmEvent,'id'|'lead_id'|'title'|'metadata'>&{company_name:string}>
  performance:Array<{id:string;name:string;prospects:number;won:number;linked:number;pipeline_arr:number}>
}
export interface CrmDetail {lead:CrmLead;activities:CrmEvent[];notes:Array<{id:string;note:string;created_at:string}>}
export const salesCrm = {
  overview:(params:Record<string,string|number>)=>api.get<CrmOverview>('/api/platform/crm',{params:Object.fromEntries(Object.entries(params).filter(([,value])=>value!==''))}),
  detail:(id:string)=>api.get<CrmDetail>(`/api/platform/crm/leads/${id}`),
  create:(body:unknown)=>api.post('/api/platform/crm/leads',body),
  update:(id:string,body:unknown)=>api.patch(`/api/platform/crm/leads/${id}`,body),
  addActivity:(id:string,body:unknown)=>api.post(`/api/platform/crm/leads/${id}/activities`,body),
  complete:(leadId:string,id:string)=>api.post(`/api/platform/crm/leads/${leadId}/activities/${id}/complete`,{}),
  accounts:()=>api.get('/api/platform/crm/accounts'),
  commissions:(page:number)=>api.get('/api/platform/crm/commissions',{params:{page}}),
  governance:()=>api.get('/api/platform/crm/governance'),
  modules:(body:unknown)=>api.put('/api/platform/crm/governance/modules',body),
  team:(body:unknown)=>api.put('/api/platform/crm/governance/team',body),
  linkCustomer:(id:string,tenantId:string)=>api.post(`/api/platform/crm/leads/${id}/customer`,{tenantId}),
}
